import IFormType from "./IFormType"
import { IHavainnotFormSchema } from "./IFormSchema";
import SGUser from "./IHavainnotUser";
import { ILocationData } from "@/sg-kohderekisterit/IKohderekisteri";
import { IFormSchema } from "@/@auditoinnit/auditoinnit/interfaces/IFormSchema";

export enum EObservationStatus {
    New = "uusi",
    InProgress = "kasittelyssa",
    Finished = "kasitelty",
    Late = "myohassa",
    Unknown = "tuntematon",
}

export const isObservationStatus = (candidate: string): candidate is EObservationStatus => {
    return [EObservationStatus.New, EObservationStatus.Late, EObservationStatus.InProgress, EObservationStatus.Finished]
        .includes(candidate as EObservationStatus);
};

interface IKnownObservationFormData {
    merkinnat?: IProcessForm[];
    karttasijainti?: { marker?: string }
}

export default interface IObservation {
    id: number;
    guid: string;
    name: string;
    creator: number;
    formType: number;
    target: ILocationData["id"];
    work?: number;
    status: EObservationStatus;

    mapLocation?: string;

    searchText: string;

    title: string;
    description: string;
    image: string;
    formData: IKnownObservationFormData & { [key: string]: any };
    formSchema?: IHavainnotFormSchema;
    is_public: boolean;
    editor?: number;
    created_at: string;
    isEditor: boolean;

    processingFormSchema?: IFormSchema;
    classificationText?: string;
}

export interface INewObservation extends Partial<IObservation> {
    //   creator: number;
    formType: number;
    title: string;
    status: EObservationStatus;
    name: string;
    description?: string;
    image?: string;
    is_public: boolean;
    formData: IKnownObservationFormData & { [key: string]: any };
    formSchema?: IHavainnotFormSchema;
    created_at: string;
    searchText: string;
}

export interface IObservationListSearch {
    whose?: "own" | "all";
    category?: number;
    status?: string;
    roles?: string[];
    creator?: number;
    handler?: number;
}

export interface IObservationCounters {
    new: number;
    onHandling: number;
    ready: number;
}

export const makeObservationSkeleton = (formType: IFormType, user: SGUser | null, isPublic: boolean): INewObservation => {
    const created_at = new Date().toISOString()
    return ({
        work: formType.workflow,
        //  creator: 1, // userId, Should havainto app id currently is gate id wich breaks the API calls.
        name: formType.name,
        title: formType.name,
        formType: formType.id,
        formData: {
            ilmottaja: user?.fullname
        },
        status: EObservationStatus.New,
        is_public: isPublic,
        created_at,
        searchText: ""
    });
}

export type TClassificationText = Array<string> | Array<number> | string | number | undefined;

export enum EProcessingMarkingPublicity {
    All = "kaikki",
    None = "ei_mikaan",
    Last = "viimeisin"
}

interface IKnownProcessFormData {
    on_julkinen?: boolean;
    kasittelymerkintojen_julkisuus?: EProcessingMarkingPublicity;
    tila?: EObservationStatus;
    kuvat?: Array<{ id: string }>;
    lisatiedot?: string;
    luokitteluteksti?: TClassificationText;
}

export interface IProcessForm {
    observationId: number;
    creator?: number;
    created_at: string;
    formData: IKnownProcessFormData & { [key: string]: any }
    formType: number;
}

export const makeProcessFormSkeleton = (
    observation: IObservation,
    userId: number,
    isPublic: boolean,
    processingMarkingPublicity: EProcessingMarkingPublicity,
    formType?: IFormType,
    classificationText?: TClassificationText
): IProcessForm => {
    const created_at = new Date().toISOString();
    return ({
        formData: {
            on_julkinen: isPublic,
            kasittelymerkintojen_julkisuus: processingMarkingPublicity,
            luokitteluteksti: classificationText
        },
        observationId: observation.id,
        //  creator: 1,
        created_at,
        formType: 0 // //currently uses simple hard coded JSON schema in "/src/constants/turvallisuushavainto.test.schema.json"
    })
}